<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 purchases-delivery-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_DELIVERIES.ADD_PURCHASES_DELIVERY") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchases-delivery-form
              :loading="loading"
              :purchasesDeliveryData="purchasesDelivery"
              :formErrors="formErrors"
              @purchasesDeliveriesubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesDelivery from "./defaultPurchasesDelivery";
import PurchasesDeliveryForm from "./partials/PurchasesDeliveryForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesDeliveryForm,
  },

  mixins: [alertLeave],

  data() {
    const purchasesDelivery = cloneDeep(defaultPurchasesDelivery);
    if (this.$currentUserIsLevelOrganization()) {
      purchasesDelivery.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      purchasesDelivery: purchasesDelivery,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List PurchasesDeliveries" });
    },

    viewPurchasesDelivery(purchasesDelivery) {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesDelivery",
        params: { id: purchasesDelivery.id },
      });
    },

    async handleSubmit(purchasesDelivery) {
      this.loading = true;
      const purchasesDeliveryData = cloneDeep(purchasesDelivery);
      if (!purchasesDeliveryData.destinationWarehouse.id) {
        delete purchasesDeliveryData.destinationWarehouse;
      }
      try {
        await this.$store.dispatch(
          "purchasesDeliveries/add",
          purchasesDeliveryData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_DELIVERIES.PURCHASES_DELIVERY_ADDED"),
        });
        const purchasesDelivery = await this.$store.getters[
          "purchasesDeliveries/purchasesDelivery"
        ];
        this.viewPurchasesDelivery(purchasesDelivery);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
